import * as React from "react";
import { FC } from "react";
import { Edit, EditProps } from "react-admin";
import { TitleMelCategory } from "./Constant/Source";
import MelCategoryEditForm from "./Forms/MelCategoryEditForm";

const MelCategoryEdit: FC<EditProps> = props => {
  return (
    <Edit title={TitleMelCategory.edit} component="div" {...props}>
      <MelCategoryEditForm {...props} />
    </Edit>
  );
};

export default MelCategoryEdit;
